import { imgs } from '../../constants/images'
import ColumnFolder from './columnFolder'
import GridFolder from './gridFolder'
type Props = {
    step: any
    viewType: string
    level1: any
    level2: any
    level3: any
    level4: any
    setLevel1: any
    setLevel2: any
    setLevel3: any
    setLevel4: any
    setLevelFiles: any
    setOpenFile: any
    setFile: any
    levelfiles: any
    inputFolder: any
    setInputFolder: any
    handleStepUpdate: any
    loadData: any
    loadDataLevel: any
    handleClickOpenCreate: any
    permit?: any
}
export default function Folder(props: Props) {
    const {
        step,
        viewType,
        level1,
        level2,
        level3,
        level4,
        setLevel1,
        setLevel2,
        setLevel3,
        setLevel4,
        setLevelFiles,
        setInputFolder,
        setFile,
        levelfiles,
        inputFolder,
        setOpenFile,
        handleStepUpdate,
        loadData,
        loadDataLevel,
        handleClickOpenCreate,
        permit
    } = props
    return (
        <>
            {viewType === 'column' ? level1?.detailFolders?.length === 0 && level1?.detailFiles?.length === 0 ?
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20px auto' }}>
                    <img src={imgs.myDocumentImage} alt='myDocumentImage' />
                </div>
                :
                <ColumnFolder
                    step={step}
                    viewType={viewType}
                    level1={level1}
                    level2={level2}
                    level3={level3}
                    level4={level4}
                    setLevel1={setLevel1}
                    setLevel2={setLevel2}
                    setLevel3={setLevel3}
                    setLevel4={setLevel4}
                    setLevelFiles={setLevelFiles}
                    setFile={setFile}
                    setOpenFile={setOpenFile}
                    levelfiles={levelfiles}
                    inputFolder={inputFolder}
                    setInputFolder={setInputFolder}
                    handleStepUpdate={handleStepUpdate}
                    loadData={loadData}
                    loadDataLevel={loadDataLevel}
                    handleClickOpenCreate={handleClickOpenCreate}
                    permit={permit} /> :
                <>
                    <GridFolder
                        step={step}
                        viewType={viewType}
                        level1={level1}
                        level2={level2}
                        level3={level3}
                        level4={level4}
                        setLevel1={setLevel1}
                        setLevel2={setLevel2}
                        setLevel3={setLevel3}
                        setLevel4={setLevel4}
                        setLevelFiles={setLevelFiles}
                        setFile={setFile}
                        setOpenFile={setOpenFile}
                        levelfiles={levelfiles}
                        inputFolder={inputFolder}
                        setInputFolder={setInputFolder}
                        handleStepUpdate={handleStepUpdate}
                        loadData={loadData}
                        loadDataLevel={loadDataLevel}
                        handleClickOpenCreate={handleClickOpenCreate}
                        permit={permit} />
                </>
            }
        </>
    )
}
